<template>
  <div id="app">
    <header>
      <h1>Faculty of Medical and Health Sciences</h1>
    </header>
    <blurb/>
    <project-list/>
  </div>
</template>

<script>
import ProjectList from './components/ProjectList.vue'
import Blurb from './components/Blurb.vue'

export default {
  name: 'App',
  components: {
    ProjectList,Blurb
  }
}
</script>

<style>
@import "styles/base.css";
@import "styles/tableview.css";
</style>
